import isEqual from 'lodash.isequal'
import React, { memo } from 'react'

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15 4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V10.5H5.17422C4.31987 10.5 3.85896 11.5021 4.41496 12.1508L11.2407 20.1142C11.6398 20.5798 12.3602 20.5798 12.7593 20.1142L19.585 12.1508C20.141 11.5021 19.6801 10.5 18.8258 10.5H15V4Z"
      fill="#DADADA"
    />
  </svg>
)

const ArrowDownUploadFile = memo(SvgComponent, isEqual)
export default ArrowDownUploadFile
